import { createBrowserRouter } from "react-router-dom";
// // import { BrowserRouter, Routes, Route } from "react-router-dom";

// PAGES

import CheckEmail from "../components/authentication/checkEmail";
import CodeVerification from "../components/authentication/codeVerification";
import ForgotPassword from "../components/authentication/forgotPassword";
import Login from "../components/authentication/login";
import ResetPassword from "../components/authentication/resetPassword";
import Error404Page from "../components/error/Error404Page";

// APP
import AddNewCustomers from "../components/app/customer_management/add_new_customer";
import Customers from "../components/app/customer_management/customer_management";
import Dashboard from "../components/app/dashboard/dashboard";
import AddNewFacility from "../components/app/facility_management/add_new_facility";
import Facilities from "../components/app/facility_management/facilities";

import CampaignManagement from "../components/app/compaign_management/campaign_management";
import Setting from "../components/app/settings/setting";
import SurveyManagement from "../components/app/survey_management/survey_management";
import TicketManagement from "../components/app/ticket_management/ticket_management";

// FACILITY
import ViewCustomer from "../components/facility/customer_management/view_customer";
import DashboardFacility from "../components/facility/dashboard/dashboard";
import Onboarding from "../components/facility/onboarding/onboarding";
import CreateLease from "../components/facility/lease_management/lease/create_lease";
import LeaseManagement from "../components/facility/lease_management/lease/lease_management";
import CreateLeaseTemplate from "../components/facility/lease_management/lease/lease_templates/create_lease_template";
import LeaseTemplates from "../components/facility/lease_management/lease/lease_templates/lease_template_management";
import ViewLeaseTemplate from "../components/facility/lease_management/lease/view_lease";
import LeaseInvoicePage from "../components/facility/lease_management/lease_invoice/InvoiceManagement";
import LeaseInvoices from "../components/facility/lease_management/lease_invoice/lease_invoices";
import AddLeasePenalty from "../components/facility/lease_management/penalty_reminders/add_penalty";
import AddLeaseReminder from "../components/facility/lease_management/penalty_reminders/add_reminder";
import LeasePenalties from "../components/facility/lease_management/penalty_reminders/PenaltyReminderSelector";
import LeaseReports from "../components/facility/lease_management/reports/reports";
import AddNewUnit from "../components/facility/unit_management/add_new_unit";
import UnitManagement from "../components/facility/unit_management/unit_management";

import AddCustomer from "../components/facility/customer_management/add_customer";
import CustomerManagement from "../components/facility/customer_management/customers";
import AddContract from "../components/facility/levy_management/contracts/add_contract";
import LevyContract from "../components/facility/levy_management/contracts/levy_contract";
import LevyInvoicingManagement from "../components/facility/levy_management/Invoicing/levy_invoicing";
import AddLevy from "../components/facility/levy_management/levies/add_levy";
import LevyManagement from "../components/facility/levy_management/levies/levy_list";
import PaymentReceipt from "../components/facility/levy_management/receipts/invoiceReceipt";
import LevyReports from "../components/facility/levy_management/reports/reports";
import FacilityPayments from "../components/facility/payment_management/facility_payment";
import CommonAreaUtility from "../components/facility/utility_management/common_area_utility/common_area_management";

// import VisitorRegistration from "../components/facility/visitor_access_management/visitor_registration/visitor_registration";
import AccessPoints from "../components/app/access_points/access_points";
import CreateMoveInHandover from "../components/facility/handover_management/create_move_in_handover";
import CreateMoveOutHandover from "../components/facility/handover_management/create_move_out_handover";
import HandoverManagement from "../components/facility/handover_management/handover_management";
import HandoverReports from "../components/facility/handover_management/reports/handover_reports";
import InvoicePage from "../components/facility/levy_management/Invoicing/invoice_management/InvoicePage";
import LevySettings from "../components/facility/levy_management/levy_settings/settings";
import maintenanceRouter from "../components/facility/maintenance_management/routes";
import FacilitySettings from "../components/facility/settings_management/settings";
import StartReview from "../components/facility/ticket_management/start_review";
import Tickets from "../components/facility/ticket_management/tickets";
import ViewTicket from "../components/facility/ticket_management/view_ticket";
import utilityRouter from "../components/facility/utility_management/routes";
import VasInvoicePage from "../components/facility/value_added_services/components/invoice_page";
import ServiceManagement from "../components/facility/value_added_services/service_list";
import ServiceVendor from "../components/facility/value_added_services/service_vendors";
import VasInvoices from "../components/facility/value_added_services/vas_invoices";
import DigitalLogs from "../components/facility/visitor_access_management/digital_logs/digital_logs";
import AddEntryAndExit from "../components/facility/visitor_access_management/entires_and_exisits/add_entry_and_exit";
import EntriesAndExists from "../components/facility/visitor_access_management/entires_and_exisits/entries_and_exists";
import GuardList from "../components/facility/visitor_access_management/guard_management/guard_registration";
import RegisterGuard from "../components/facility/visitor_access_management/guard_management/register_guard";
import VisitorManagementHome from "../components/facility/visitor_access_management/home/home";
import ScanQRCode from "../components/facility/visitor_access_management/qrcode/scan_qr_code";
import VerifyCode from "../components/facility/visitor_access_management/verifycode/verify_code";
import Deliveries from "../components/facility/visitor_access_management/visitor_registration/deliveries";
import GateRegistration from "../components/facility/visitor_access_management/visitor_registration/gate_registration";
import ViewWaitingList from "../components/facility/visitor_access_management/wait_list/view_waiting_list";
import WaitingList from "../components/facility/visitor_access_management/wait_list/waiting_list";

import accountsRoutes from "../components/facility/accounts/routes";
import AddCampaign from "../components/facility/campaign_management/add_campaign";
import Campaigns from "../components/facility/campaign_management/campaigns";
import expenseRoutes from "../components/facility/expense_and_budget_mgmnt/expense_and_budget.routes";
import UniversalInvoicePage from "../components/facility/levy_management/Invoicing/offline_invoice/invoice_management/UniversalInvoicePage";
import procurementRoutes from "../components/facility/procurement_management/procurement_routes";
import RaiseTicket from "../components/facility/ticket_management/raise_ticket";
import StaffNotification from "../components/facility/ticket_management/staff_notification";
import ViewUnit from "../components/facility/unit_management/view_unit";
import GetDigitalLog from "../components/facility/visitor_access_management/digital_logs/get_digital_log";

import BookingDashboard from "../components/facility/booking_management/booking_dashboard";
import BookingInvoice from "../components/facility/booking_management/booking_invoices/booking_invoice_management";
import UnitListing from "../components/facility/booking_management/unit_listing";
import BookingSettings from "../components/facility/booking_management/booking_settings/settings";
import BookingWidget from "../components/public/booking_widget/BookingWidget";

//property management
import CreatePropertyManagerContract from "../components/facility/property_management/contracts/CreatePropertyManagerContract";
import PropertyContractManagement from "../components/facility/property_management/contracts/PropertyContractManagement";
import PropertyManagedCustomers from "../components/facility/property_management/PropertyManagedCustomers";
import PropertyManagedInvoices from "../components/facility/property_management/PropertyManagedInvoices";
import PMInvoicePage from "../components/facility/property_management/InvoicePage";
import PropertyManagement from "../components/facility/property_management/PropertyManagedUnits";
import PropertyManagerRevenue from "../components/facility/property_management/PropertyManagerRevenue";

// facility reports for Lease, Levy, Utility
import FacilityLeaseReports from "../components/facility/lease_management/reports/lease_reports";
import FacilityLevyReports from "../components/facility/levy_management/reports/levy_reports";
import FacilityLevyDeposits from "../components/facility/levy_management/deposits/levy_deposits";
import FacilityUtilityReports from "../components/facility/utility_management/reports/utility_reports";
import DepositReceipt from "../components/facility/levy_management/deposits/deposit_receipt";

import SupplierRFQManagement from "../components/facility/supplier_rfq_management/rfqs_management";
import ViewCampaign from "../components/facility/campaign_management/view_campaign";
import AllReports from "../components/facility/reports/all_reports";
import AuditLogs from "../components/facility/audit_logs/audit_logs";
import CombinedInvoices from "../components/facility/combined_invoices/combined_invoices";
import CombinedInvoicePage from "../components/facility/combined_invoices/view_combined_invoice";
import AssignedTickets from "../components/facility/ticket_management/assigned_tickets";
import OfflineFAQ from "../components/facility/offline_pages/faq";
import PrivacyPolicy from "../components/facility/offline_pages/privacy_policy";
import TermsAndConditions from "../components/facility/offline_pages/terms";
import LandlordDeactivation from "../components/facility/customer_management/landlord_deactivation";
import VASvendors from "../components/facility/value_added_services/vas_vendors";
import VendorApproval from "../components/facility/value_added_services/vendor_approval";
import PMQuoteApproval from "../components/facility/value_added_services/pm_approval";
import RegisterReceptionist from "../components/facility/visitor_access_management/receptionist_management/add_receptionist";
import ReceptionManagement from "../components/facility/visitor_access_management/receptionist_management/reception";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    // Public, no-auth booking widget meant to be embedded via <iframe> in a
    // third-party site. Takes ?facility_id=... or ?company_id=....
    path: "/booking-widget",
    element: <BookingWidget />,
  },
  {
    path: "/forgot_password",
    element: <ForgotPassword />,
  },
  {
    path: "/check_email",
    element: <CheckEmail />,
  },
  {
    path: "/code_verification",
    element: <CodeVerification />,
  },
  {
    path: "/reset_password/:userId",
    element: <ResetPassword />,
  },
  {
    path: "/app/",
    element: <Dashboard />,
  },
  {
    path: "/app/facilities",
    element: <Facilities />,
  },
  {
    path: "/app/add_new_facility",
    element: <AddNewFacility />,
  },
  {
    path: "/app/campaign_management",
    element: <CampaignManagement />,
  },
  {
    path: "/app/customer_management",
    element: <Customers />,
  },
  {
    path: "/app/customer_management/add_new_customer",
    element: <AddNewCustomers />,
  },
  {
    path: "/app/ticket_management",
    element: <TicketManagement />,
  },

  {
    path: "/app/survey_management",
    element: <SurveyManagement />,
  },
  {
    path: "/facility/",
    element: <DashboardFacility />,
  },
  {
    path: "/facility/onboarding",
    element: <Onboarding />,
  },
  {
    path: "/facility/settings_management/settings",
    element: <FacilitySettings />,
  },
  {
    path: "/facility/unit_management",
    element: <UnitManagement />,
  },
  {
    path: "/facility/unit_management/add_new_unit",
    element: <AddNewUnit />,
  },
  {
    path: "/facility/customer_management/customers",
    element: <CustomerManagement />,
  },
  {
    path: "/facility/customer_management/view_customer/:customerId",
    element: <ViewCustomer />,
  },
  {
    path: "/facility/customer_management/add_new_customer",
    element: <AddCustomer />,
  },
  {
    path: "/facility/customer_management/landlord_deactivation/:customerId",
    element: <LandlordDeactivation />,
  },
  {
    path: "/facility/lease_management/leases",
    element: <LeaseManagement />,
  },
  {
    path: "/facility/lease_management/create_lease",
    element: <CreateLease />,
  },
  {
    path: "/facility/lease_management/lease_templates",
    element: <LeaseTemplates />,
  },
  {
    path: "/facility/booking_management/create_lease_templates",
    element: <CreateLeaseTemplate />,
  },

  {
    path: "/facility/lease_management/lease/view_lease/:leaseId",
    element: <ViewLeaseTemplate />,
  },

  {
    path: "/facility/lease_management/lease_penalties",
    element: <LeasePenalties />,
  },

  {
    path: "/facility/lease_management/lease_invoices",
    element: <LeaseInvoices />,
  },

  {
    path: "/facilitiy/lease_management/reports",
    element: <LeaseReports />,
  },

  {
    path: "/facilitiy/lease_management/lease_reports",
    element: <FacilityLeaseReports />,
  },
  {
    path: "/facilitiy/levy_management/levy_reports",
    element: <FacilityLevyReports />,
  },
  {
    path: "/facilitiy/levy_management/levy_deposits",
    element: <FacilityLevyDeposits />,
  },
  {
    path: "/facility/levy_management/deposit-receipt/:receiptNumber",
    element: <DepositReceipt />,
  },
  {
    path: "/facilitiy/utility_management/utility_reports",
    element: <FacilityUtilityReports />,
  },
  {
    path: "/facility/lease_management/lease_penalties/add_penalty",
    element: <AddLeasePenalty />,
  },

  {
    path: "/facility/lease_management/lease_penalties/add_reminder",
    element: <AddLeaseReminder />,
  },

  {
    path: "/facility/levy_management/",
    element: <LevyManagement />,
  },
  {
    path: "/facility/supplier_rfq_management/rfqs_management",
    element: <SupplierRFQManagement />,
  },
  {
    path: "/facility/levy_management/receipt/:receiptId",
    element: <PaymentReceipt />,
  },
  {
    path: "/facility/payment_management/:facilityId",
    element: <FacilityPayments />,
  },
  {
    path: "/facility/common_area_management/:facilityId",
    element: <CommonAreaUtility />,
  },
  {
    path: "/facility/reports/all_reports",
    element: <AllReports />,
  },
  {
    path: "/facility/audit_logs",
    element: <AuditLogs />,
  },
  {
    path: "/facility/combined_invoices/combined_invoices",
    element: <CombinedInvoices />,
  },
  {
    path: "/facility/combined_invoices/view_combined_invoice/:combinedInvoiceId",
    element: <CombinedInvoicePage />,
  },
  {
    path: "/facility/levy_management/invoice/:invoiceId",
    element: <InvoicePage />,
  },
  {
    path: "/facility/lease_management/invoice/:invoiceId",
    element: <LeaseInvoicePage />,
  },

  {
    path: "/facility/levy_management/levies/add_levy",
    element: <AddLevy />,
  },
  {
    path: "/facility/levy_management/contracts",
    element: <LevyContract />,
  },
  {
    path: "/facility/levy_management/contracts/add_contract",
    element: <AddContract />,
  },
  {
    path: "/facilitiy/levy_management/levy_invoicing",
    element: <LevyInvoicingManagement />,
  },
  {
    path: "/facilitiy/levy_management/reports",
    element: <LevyReports />,
  },
  {
    path: "/app/access_points",
    element: <AccessPoints />,
  },
  {
    path: "/facility/visitor_access_management/home",
    element: <VisitorManagementHome />,
  },
  {
    path: "/facility/visitor_access_management/reception",
    element: <ReceptionManagement />,
  },
  {
    path: "/facility/visitor_access_management/add_receptionist",
    element: <RegisterReceptionist />,
  },
  {
    path: "facility/visitor_access_management/guard_list",
    element: <GuardList />,
  },
  {
    path: "/facility/visitor_access_management/guard_management/register_guard",
    element: <RegisterGuard />,
  },
  {
    path: "facility/visitor_access_management/digital_logs",
    element: <DigitalLogs />,
  },
  {
    path: "facility/visitor_access_management/view_digital_log/:visitLogId",
    element: <GetDigitalLog />,
  },
  {
    path: "/facility/visitor_access_management/entries_and_exits",
    element: <EntriesAndExists />,
  },
  {
    path: "/facility/visitor_access_management/entries_and_exits/add_entry_and_exit",
    element: <AddEntryAndExit />,
  },
  {
    path: "/facility/visitor_access_management/scan_qr_code",
    element: <ScanQRCode />,
  },
  {
    path: "/facility/visitor_access_management/verify_code",
    element: <VerifyCode />,
  },
  {
    path: "/facility/visitor_access_management/visitor_registration/gate_registration",
    element: <GateRegistration />,
  },
  {
    path: "/facility/visitor_access_management/visitor_registration/deliveries",
    element: <Deliveries />,
  },
  {
    path: "/facility/visitor_access_management/waiting_list",
    element: <WaitingList />,
  },
  {
    path: "/facility/visitor_access_management/view_waiting_list/:visitLogId",
    element: <ViewWaitingList />,
  },
  {
    path: "/app/survey_management",
    element: <SurveyManagement />,
  },
  {
    path: "/app/settings",
    element: <Setting />,
  },
  // {
  //   path: "/facility/settings",
  //   element: <Settings />,
  // },
  {
    path: "/facility/",
    element: <DashboardFacility />,
  },
  {
    path: "/facility/unit_management",
    element: <UnitManagement />,
  },
  {
    path: "/facility/unit_management/view_unit/:unitId",
    element: <ViewUnit />,
  },
  {
    path: "/facility/unit_management/add_new_unit",
    element: <AddNewUnit />,
  },
  {
    path: "/facility/customer_management/customers",
    element: <CustomerManagement />,
  },
  {
    path: "/facility/customer_management/add_new_customer",
    element: <AddCustomer />,
  },
  {
    path: "/facility/lease_management/",
    element: <LeaseManagement />,
  },

  {
    path: "/facilitiy/lease_management/reports",
    element: <LeaseReports />,
  },
  {
    path: "/facility/levy_management/",
    element: <LevyManagement />,
  },
  {
    path: "/facility/levy_management/levies/add_levy",
    element: <AddLevy />,
  },
  {
    path: "/facility/levy_management/contracts",
    element: <LevyContract />,
  },
  {
    path: "/facility/levy_management/contracts/add_contract",
    element: <AddContract />,
  },
  {
    path: "/facilitiy/levy_management/levy_invoicing",
    element: <LevyInvoicingManagement />,
  },
  {
    path: "/facilitiy/levy_management/reports",
    element: <LevyReports />,
  },
  {
    path: "/facility/levy_management/settings",
    element: <LevySettings />,
  },
  {
    path: "facility/ticket_management/tickets",
    element: <Tickets />,
  },
  {
    path: "facility/ticket_management/raise_ticket",
    element: <RaiseTicket />,
  },
  {
    path: "facility/ticket_management/view_ticket/:ticketId",
    element: <ViewTicket />,
  },
  {
    path: "facility/ticket_management/start_review/:ticketId",
    element: <StartReview />,
  },
  {
    path: "facility/ticket_management/staff_notification/:ticketId",
    element: <StaffNotification />,
  },
  {
    path: "facility/ticket_management/assigned_tickets",
    element: <AssignedTickets />,
  },
  {
    path: "/facility/value_added_services/service_list",
    element: <ServiceManagement />,
  },
  {
    path: "/facility/value_added_services/service_vendors",
    element: <ServiceVendor />,
  },
  {
    path: "/facility/value_added_services/vas_vendors",
    element: <VASvendors />,
  },
  {
    path: "/facility/value_added_services/approve",
    element: <VendorApproval />,
  },
  {
    path: "/facility/value_added_services/pm_approve",
    element: <PMQuoteApproval />,
  },
  {
    path: "/facility/value_added_services/vas_invoices",
    element: <VasInvoices />,
  },
  {
    path: "/facility/value_added_services/invoice/:invoiceId",
    element: <VasInvoicePage />,
  },
  {
    path: "/facility/booking_management/unit_listing",
    element: <UnitListing />,
  },
  {
    path: "/facility/handover_management/handovers/",
    element: <HandoverManagement />,
  },
  {
    path: "/facility/handover_management/add_move_in_handover",
    element: <CreateMoveInHandover />,
  },
  {
    path: "/facility/handover_management/add_move_out_handover",
    element: <CreateMoveOutHandover />,
  },
  {
    path: "/facility/handover_management/reports",
    element: <HandoverReports />,
  },
  {
    path: "/facility/campaigns",
    element: <Campaigns />,
  },
  {
    path: "/facility/campaigns/add_campaign",
    element: <AddCampaign />,
  },
  {
    path: "/facility/campaigns/view_campaign/:campaignId",
    element: <ViewCampaign />,
  },

  // Universal invoice route that supports both levy and lease invoices
  {
    path: "/invoice/:facilityId/:invoiceId/:type?",
    element: <UniversalInvoicePage />,
  },

  ...maintenanceRouter,
  ...expenseRoutes,
  ...utilityRouter,
  ...procurementRoutes,
  ...accountsRoutes,
  {
    path: "*",
    element: <Error404Page />,
  },


  //booking management
  {
    path: "/facility/booking_management",
    element: <BookingDashboard />

  },
  {
    path: "/facility/booking_management/invoices",
    element: <BookingInvoice />
  },
  {
    path: "/facility/booking_management/settings",
    element: <BookingSettings />
  },

  //property management
  {
    path: "/facility/property_management",
    element: <PropertyManagement />
  },

  {
    path: "/facility/property_management/property_invoices",
    element: <PropertyManagedInvoices />
  },
  {
    path: "/facility/property_management/property_invoices/pm_invoice/:invoiceId",
    element: <PMInvoicePage />
  },
  {
    path: "/facility/property_management/property_revenue",
    element: <PropertyManagerRevenue />
  },
  {
    path: "/facility/property_management/property_customers",
    element: <PropertyManagedCustomers />
  },
  {
    path: "/facility/property_management/property_manager_contract",
    element: <CreatePropertyManagerContract />
  },
  {
    path: "/facility/property_management/property_contract_management",
    element: <PropertyContractManagement />
  },
  {
    path: "/faqs",
    element: <OfflineFAQ />
  },
  {
    path: "/privacy_policy",
    element: <PrivacyPolicy />
  },
  {
    path: "/terms_and_conditions",
    element: <TermsAndConditions />
  },

],
{
    basename: process.env.PUBLIC_URL || '/',
  });
